import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const CanvasList = lazy(() =>
  import("@canvas/CanvasList").then((module) => ({
    default: module.CanvasList,
  }))
);

export const canvasNRO: NavigationRoutingObject = {
  Component: CanvasList,
  componentFeatureFlippers: ["canvas_nro_component"],
  section: "messaging",
  heading: (t: I18nT<"dashboard-navigation">) => t("canvas-sidebar-pill-menu-option", "Canvas"),
  pageNameForTracking: () => "Canvas",
  description: (t: I18nT<"dashboard-navigation">) =>
    t(
      "canvas-sidebar-pill-menu-option-description",
      "Manage your existing Canvases or create a new one. Recommended for user journeys."
    ),
  icon: "new-nav-system-canvas",
  getDeveloperNavigationAllowed: ({ featureOn }) => {
    return featureOn("journeys");
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/engagement/canvas/:appGroupId",
};
